export const STATIC_PACKAGES = [
  {
    "title": "Dubai Dazzler",
    "destination": "Dubai, UAE",
    "region": "international",
    "duration": "5 Days / 4 Nights",
    "price": 54999,
    "image": "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=85&w=1600&auto=format&fit=crop",
    "highlights": [
      "Burj Khalifa",
      "Desert Safari",
      "Dhow Cruise",
      "Visa Included"
    ],
    "tag": "Bestseller"
  },
  {
    "title": "Thailand Escape",
    "destination": "Bangkok & Phuket",
    "region": "international",
    "duration": "6 Days / 5 Nights",
    "price": 42999,
    "image": "https://images.unsplash.com/photo-1745837112372-42e4e5b62e80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHx0aGFpbGFuZCUyMGJlYWNoJTIwc3Vuc2V0fGVufDB8fHx8MTc4ODE2NzY4N3ww&ixlib=rb-4.1.0&q=85",
    "highlights": [
      "Phi Phi Island",
      "Safari World",
      "Coral Island"
    ],
    "tag": null
  },
  {
    "title": "Bali Serenity",
    "destination": "Bali, Indonesia",
    "region": "international",
    "duration": "6 Days / 5 Nights",
    "price": 58999,
    "image": "https://images.unsplash.com/photo-1717148665537-50fce0476b7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxiYWxpJTIwdGVtcGxlJTIwanVuZ2xlfGVufDB8fHx8MTc4ODE2NzY4N3ww&ixlib=rb-4.1.0&q=85",
    "highlights": [
      "Uluwatu Temple",
      "Ubud Rice Terraces",
      "Water Sports"
    ],
    "tag": "Honeymoon Pick"
  },
  {
    "title": "Singapore Splendour",
    "destination": "Singapore",
    "region": "international",
    "duration": "5 Days / 4 Nights",
    "price": 62999,
    "image": "https://images.unsplash.com/photo-1496939376851-89342e90adcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzaW5nYXBvcmUlMjBtYXJpbmElMjBiYXklMjBzYW5kcyUyMG5pZ2h0fGVufDB8fHx8MTc4ODE2NjkzfDA&ixlib=rb-4.1.0&q=85",
    "highlights": [
      "Marina Bay Sands",
      "Sentosa",
      "Universal Studios"
    ],
    "tag": null
  },
  {
    "title": "Goa Getaway",
    "destination": "North & South Goa",
    "region": "domestic",
    "duration": "4 Days / 3 Nights",
    "price": 18999,
    "image": "https://images.unsplash.com/photo-1594342436424-dda50df715d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHx0aGFpbGFuZCUyMGJlYWNoJTIwc3Vuc2V0fGVufDB8fHx8MTc4ODE2NzY4N3ww&ixlib=rb-4.1.0&q=85",
    "highlights": [
      "Baga Beach",
      "Water Sports",
      "Sunset Cruise"
    ],
    "tag": null
  },
  {
    "title": "Kashmir Paradise",
    "destination": "Srinagar & Gulmarg",
    "region": "domestic",
    "duration": "6 Days / 5 Nights",
    "price": 32999,
    "image": "https://images.unsplash.com/photo-1715457573748-8e8a70b2c1be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxrYXNobWlyJTIwZGFsJTIwbGFrZSUyMHNoaWthcmF8ZW58MHx8fHwxNzg4MTY3Njk4fDA&ixlib=rb-4.1.0&q=85",
    "highlights": [
      "Dal Lake Shikara",
      "Gulmarg Gondola",
      "Houseboat Stay"
    ],
    "tag": "Most Loved"
  },
  {
    "title": "Kerala Backwaters",
    "destination": "Alleppey & Munnar",
    "region": "domestic",
    "duration": "6 Days / 5 Nights",
    "price": 28999,
    "image": "https://images.pexels.com/photos/34489429/pexels-photo-34489429.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "highlights": [
      "Private Houseboat",
      "Tea Gardens",
      "Kathakali Evening"
    ],
    "tag": null
  },
  {
    "title": "Royal Rajasthan",
    "destination": "Jaipur & Udaipur",
    "region": "domestic",
    "duration": "6 Days / 5 Nights",
    "price": 26999,
    "image": "https://images.unsplash.com/photo-1695395550316-8995ae9d35ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxyYWphc3RoYW4lMjBwYWxhY2UlMjBpbmRpYXxlbnwwfHx8fDE3ODgxNjc2ODd8MA&ixlib=rb-4.1.0&q=85",
    "highlights": [
      "Amber Fort",
      "Lake Pichola",
      "City Palace"
    ],
    "tag": null
  }
];

export const STATIC_VISAS = [
  {
    "country": "Dubai (UAE)",
    "category": "tourist",
    "processing": "3\u20135 working days",
    "price": 7499,
    "note": "30/60-day options, express available"
  },
  {
    "country": "Thailand",
    "category": "tourist",
    "processing": "4\u20136 working days",
    "price": 5999,
    "note": "E-visa assistance"
  },
  {
    "country": "Singapore",
    "category": "tourist",
    "processing": "3\u20135 working days",
    "price": 4999,
    "note": null
  },
  {
    "country": "Schengen (Europe)",
    "category": "tourist",
    "processing": "15\u201320 working days",
    "price": 12999,
    "note": "Full documentation support"
  },
  {
    "country": "USA (B1/B2)",
    "category": "tourist",
    "processing": "Appointment + filing",
    "price": 18999,
    "note": "Interview preparation included"
  },
  {
    "country": "Indonesia (Bali)",
    "category": "tourist",
    "processing": "2\u20133 working days",
    "price": 2999,
    "note": "E-VOA assistance"
  },
  {
    "country": "UAE",
    "category": "work",
    "processing": "7\u201315 working days",
    "price": 24999,
    "note": "Employment & business setup visas"
  },
  {
    "country": "Singapore",
    "category": "work",
    "processing": "5\u20137 working days",
    "price": 9999,
    "note": "Business visa with invitation guidance"
  },
  {
    "country": "United Kingdom",
    "category": "work",
    "processing": "3\u20136 weeks",
    "price": 29999,
    "note": "Work permit guidance"
  },
  {
    "country": "Canada",
    "category": "work",
    "processing": "8\u201312 weeks",
    "price": 34999,
    "note": "LMIA & work permit guidance"
  }
];
